module.exports = __webpack_public_path__ + "static/img/advantage01.22e41a1.png";


//////////////////
// WEBPACK FOOTER
// ./static/home/advantage01.png
// module id = KP8D
// module chunks = 1